import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["data-test-id", "displayOptimized", "onDetailsClick", "hoverContent"];
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import DefaultHoverContent from '../input/hoverContent/DefaultHoverContent';
import { jsx as _jsx } from "react/jsx-runtime";
export default function FormControlAdapter(_ref) {
  let {
      'data-test-id': dataTestId,
      displayOptimized,
      onDetailsClick,
      hoverContent
    } = _ref,
    commonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  if (displayOptimized) {
    const resolvedHoverContent = hoverContent !== null && hoverContent !== void 0 ? hoverContent : /*#__PURE__*/_jsx(DefaultHoverContent, {
      onDetailsClick: onDetailsClick
    });
    return /*#__PURE__*/_jsx(FormControl, Object.assign({
      "data-test-id": dataTestId !== null && dataTestId !== void 0 ? dataTestId : 'DisplayOptimizedFormControl',
      displayOptimized: true,
      hoverContent: resolvedHoverContent
    }, commonProps));
  }
  return /*#__PURE__*/_jsx(FormControl, Object.assign({
    "data-test-id": dataTestId !== null && dataTestId !== void 0 ? dataTestId : 'FormControl'
  }, commonProps));
}